.d2{border-radius:0.625rem;}